<template>
	<div class="footDesc" :class="{'maxw':!isMobile}">
		<van-nav-bar v-if="isMobile" :title="$t('personal.orderTitle')" left-arrow @click-left="onClickLeft" />
		<div class="coinBox">
			  <div class="back" @click="onClickLeft">
				  {{ $t('orders.total') }}<span>（{{ $t('orders.desc') }}）</span>
			  </div>
			  <p>
			  <span class="coins">{{ $t('orders.money') }}：{{ totals.payTotal || 0 }} </span>
			  <span class="coins">{{ $t('orders.coupon') }}：{{ totals.couponAmountTotal || 0 }} </span>
			  </p>
			  <p>
			  <span class="coins">{{ $t('personal.platCoin') }}：{{ totals.platCoinTotal || 0 }} </span>
			  <span class="coins">{{ $t('orders.realpay') }}：{{ totals.realPay || 0 }}</span>
			  </p>
		</div>
		<van-dropdown-menu>
			<van-dropdown-item v-model="platformId" :options="platList" @change="onPlatConfirm" />
			<van-dropdown-item :title="$t('orders.games')" ref="gameRef" @click="handleGames">
				<van-cell center :title="gameName" :value="$t('orders.exchange')">
				  <template #right-icon>
					<van-icon name="arrow" />
				  </template>
				</van-cell>
			</van-dropdown-item>
			<van-dropdown-item :title="$t('orders.payTime')" ref="timeRef">
				<van-cell center :title="$t('orders.beginTime')" :value="beginTime" @click="handleTimes">
				  <template #right-icon>
					<van-icon name="arrow" />
				  </template>
				</van-cell>
				<van-cell center :title="$t('orders.endTime')" :value="endTime" @click="handleTimes">
				  <template #right-icon>
					<van-icon name="arrow" />
				  </template>
				</van-cell>
			</van-dropdown-item>
		</van-dropdown-menu>
		<div class="content">
			<ul v-if="orderList.length > 0">
				<li v-for="(item,index) in orderList" :key="index">
					<div class="orders">
						<div class="details">
							  <p class="title">{{ item.gameName }} [{{ item.goodName }}]</p>
						</div>
						<div class="coins">{{ item.actualMoney }}</div>
					</div>
					<div class="infos">
						<p>{{ $t('orders.gameId') }}：{{ item.gameId }}</p>
						<p>{{ $t('orders.platName') }}：{{ item.platformName || item.platformId }}</p>
						<p>{{ $t('orders.platOrder') }}：{{ item.tradeNo }}</p>
						<p>{{ $t('orders.userId') }}：{{ item.superUserId }}</p>
						<p>{{ $t('orders.serviceName') }}：{{ item.serviceName }}</p>
						<p>{{ $t('orders.roleId') }}：{{ item.roleId }}</p>
						<p>{{ $t('orders.roleName') }}：{{ item.roleName }}</p>
						<p>{{ $t('orders.money') }}：{{ item.payMoney }}</p>
						<p>{{ $t('orders.coupon') }}：{{ item.couponAmount }}</p>
						<p>{{ $t('personal.platCoin') }}：{{ item.platCoin }}</p>
						<p>{{ parseTime(item.gamePayTime) }}</p>
					</div>
				</li>
			</ul>
			<van-empty v-else image-size="100" description="- Empty -" />
		</div>
	<van-action-sheet v-model:show="showTimeSearch">
	  <div class="content">
		  <van-picker-group
		    :title="$t('orders.payTime')"
		    :tabs="[$t('orders.beginTime'), $t('orders.endTime')]"
			:cancel-button-text="$t('common.cancel')"
			:confirm-button-text="$t('common.confirm')"
		    @confirm="onTimeConfirm"
		    @cancel="onTimeCancel"
		  >
		    <van-date-picker
		      v-model="startDate"
		      :min-date="minDate"
		      :max-date="maxDate"
			  @change="handleTimesLimit"
		    />
		    <van-date-picker
		      v-model="endDate"
		      :min-date="endMinDate"
		      :max-date="endMaxDate ? endMaxDate : maxDate"
		    />
		  </van-picker-group>
	  </div>
	</van-action-sheet>
	<van-action-sheet v-model:show="showGameSearch" :title="$t('orders.searchGame')">
	  <div class="content">
		  <van-search background="#efefef"
		      v-model="gameSearch"
		      show-action
		      :placeholder="$t('orders.gamePlace')"
			  @update:model-value="handleGameSearch"
		      @cancel="onGameCancel"
		    >
			<template #action>
			    <div @click="onGameSearch(gameSearch)">{{ $t('common.search') }}</div>
			  </template>
		  </van-search>
			<div class="itemList van-action-sheet__content">
				<ul>
					<li class="van-action-sheet__item" @click="onGameConfirm($t('orders.all'),'')">{{ $t('orders.all') }}</li>
					<li class="van-action-sheet__item" v-for="(item,index) in gameList" :key="index" @click="onGameConfirm(item,index)">{{ item }}</li>
				</ul>
			</div>
	  </div>
	</van-action-sheet>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed } from 'vue'
	import { useRoute,useRouter } from 'vue-router';
	import useConfigStore from '@/store/modules/config'
	import { getOrders, getOrdersSum, getOrdersGame } from '@/api/pay.js'
	
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const content = ref('')
	const orderList = ref([])
	const totals = ref({})
	const showGameSearch = ref(false)
	const showTimeSearch = ref(false)
	const platList = ref([
		{ text: proxy.$t('orders.plats'), value: '' },
		{ text: 'SAMSUNG', value: 300000 },
		{ text: 'GOOGLE', value: 1001 },
		{ text: 'ONESTORE', value: 23118 },
		{ text: 'GM 플랫폼', value: 2004 },
	])
	const platformId = ref('')
	const gameSearch = ref('')
	const gameName = ref(proxy.$t('orders.all'))
	const gameId = ref('')
	const gameList = ref([])
	const beginTime = ref(null)
	const endTime = ref(null)
	const startDate = ref(['2025','01','01']);
	const endDate = ref([]);
	const endMinDate = computed(
	  () =>
		new Date(
		  Number(startDate.value[0]),
		  Number(startDate.value[1]) - 1,
		  Number(startDate.value[2]),
		),
	);
	const endMaxDate = ref(null)
	const minDate = ref(new Date(2020, 0, 1))
	const maxDate = ref(new Date())
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	onMounted(() => {
		let year = new Date().getFullYear()
		let month = new Date().getMonth()
		let day = new Date().getDate()
		let months = month < 10 ? '0'+month : month;
		let days = day < 10 ? '0'+day : day;
		startDate.value = [String(year),String(months),String(day)]
		endDate.value = [String(year),String(months),String(day)]
		getList()
	})
	const getList = (params = {}) => {
		getOrders(params).then((res) => {
			orderList.value = res.rows
		})
		getOrdersSum(params).then((res) => {
			totals.value = res.data
			totals.value.realPay = totals.value.payTotal - totals.value.couponAmountTotal - totals.value.platCoinTotal
		})
	}
	const onClickLeft = () => {
		history.back()
	}
	const handleSearch = () => {
		let args = {
			gameId: gameId.value,
			beginTime: beginTime.value,
			endTime: endTime.value,
			platformId: platformId.value
		}
		getList(args)
	}
	const handleGames = () => {
		showGameSearch.value = true
		handleGameSearch()
	}
	const handleTimes = () => {
		showTimeSearch.value = true
		endMaxDate.value = null
	}
	const handleTimesLimit = ({ selectedValues }) => {
		let selYear = selectedValues[0];
		let year = new Date().getFullYear();
		if(Number(selYear) < year){
			endMaxDate.value = new Date([selYear,'12','31'])
		}else{
			endMaxDate.value = null
		}
	}
	const onTimeConfirm = () => {
		beginTime.value = startDate.value.join('-')+' 00:00:00';
		endTime.value = endDate.value.join('-')+' 23:59:59';
		showTimeSearch.value = false
		handleSearch()
	};
	
	const onTimeCancel = () => {
		beginTime.value = ''
		endTime.value = ''
		showTimeSearch.value = false
		handleSearch()
	};
	const onPlatConfirm = (val) => {
		platformId.value = val
		handleSearch()
	}
	const onGameSearch = (val) => {
		console.log('搜索点击===',val)
		getOrdersGame({ gameName: val }).then((res) => {
			gameList.value = res.data
		})
	};
	const handleGameSearch = () => {
		onGameSearch(gameSearch.value)
	}
	const onGameConfirm = (name,val) => {
		gameName.value = name
		gameId.value = val
		showGameSearch.value = false
		handleSearch()
	}
	const onGameCancel = () => {
		gameSearch.value = ''
		gameName.value = ''
		gameId.value = ''
		gameList.value = []
		showGameSearch.value = false
	};
</script>

<style lang="less" scoped>
	.footDesc{
		&.maxw{
			max-width: 760px;margin: 0 auto;background: #fff;
			/deep/.van-popup{
				max-width: 760px;margin-left: 50%;transform: translate(-50%,0);
			}
		}
	}
	.coinBox{
		padding: 32px 16px 10px;width: 100%;box-sizing: border-box;
		text-align: left;color: #fff;
		background: url('~@/assets/images/common/personal_up_bg.png') no-repeat top;
		background-size: 100%;
		font-size: 16px;position: relative;
		p{
			line-height: 18px;height: 18px;
		}
		span.coins{
			font-size: 12px;display: inline-block;width: 50%;
		}
		.back{
			position: absolute;left: 16px;top: 8px;font-size: 14px;
			display: flex;align-items: center;cursor: pointer;
			span{
				font-size: 10px;color: rgba(255,255,255,0.9);
			}
		}
	}
	.content{
		width: 100%;font-size: 14px;height: calc(100vh - 248px);overflow-y: scroll;
		ul{
			padding: 0 17px;
			li{
				padding: 12px 0;
				.orders{
					display: flex;align-items: center;justify-content: space-between;
				}
				.infos{
					p{
						width: 50%;display: inline-block;font-size: 12px;color: #ccc;
					}
				}
				.details{
					flex: 1;
					p{
						font-size: 12px;color: #ccc;line-height: 18px;
					}
					.title{
						font-size: 14px;color: #2d2d2d;letter-spacing: 1px;margin: 3px 0;
					}
				}
				.conis{
					font-size: 16px;color: #00c3ff;
					span{
						font-size: 12px;display: inline-block;margin-left: 5px;
					}
				}
			}
			li + li{
				border-top: 1px solid #eee;
			}
		}
	}
</style>